'use client';

import {
  createEntityVerificationHighlightPlugin,
  entityVerificationPluginKey,
} from '@/components/tiptap/shared/entity-verification-highlight/create-plugin';
import { Extension } from '@tiptap/react';

export type { EntityMatch } from '@/components/tiptap/shared/entity-verification-highlight/create-plugin';
export { entityVerificationPluginKey };

export interface EntityVerificationHighlightOptions {
  /**
   * Whether the extension is enabled
   */
  enabled: boolean;
}

/**
 * vMarkdown twin of the entity-verification highlight. Thin `Extension.create`
 * wrapper around the shared decoration plugin — the decoration logic lives in
 * `tiptap/shared/entity-verification-highlight` so v1, vMarkdown, and
 * markdown-native all share one implementation without cross-importing.
 */
export const EntityVerificationHighlight =
  Extension.create<EntityVerificationHighlightOptions>({
    name: 'entityVerificationHighlight',

    addOptions() {
      return {
        enabled: true,
      };
    },

    addProseMirrorPlugins() {
      return [createEntityVerificationHighlightPlugin({ enabled: this.options.enabled })];
    },
  });
